export var Tiers = [
    {
        id: 1,
        label: "Legends",
        weight: 100,
        cost: 200,
        points: {
            min: 70,
            max: 100
        }
    },
    {
        id: 2,
        label: "Main eventers",
        weight: 90,
        cost: 150,
        points: {
            min: 90,
            max: 100
        }
    },
    {
        id: 3,
        label: "Upper Card",
        weight: 80,
        cost: 100,
        points: {
            min: 70,
            max: 90
        }
    },
    {
        id: 4,
        label: "Mid Card",
        weight: 70,
        cost: 75,
        points: {
            min: 50,
            max: 75
        }
    },
    {
        id: 5,
        label: "Lower Card",
        weight: 60,
        cost: 50,
        points: {
            min: 25,
            max: 50
        }
    },
    {
        id: 6,
        label: "Lower Card",
        weight: 50,
        cost: 20,
        points: {
            min: 25,
            max: 0
        }
    }
];
export var tierById = function(id) {
    return Tiers.find(function(item) {
        return item.id === id;
    });
};
